import { FeatureFlagResponse } from "../../api-models/response/FeatureFlagResponse";

export class FeatureFlag {
  id: number;
  name: string;
  isEnabled: boolean;

  constructor(featureFlagResponse: FeatureFlagResponse) {
    this.id = featureFlagResponse.id;
    this.name = featureFlagResponse.name;
    this.isEnabled = featureFlagResponse.isEnabled;
  }
}
